import { Injectable, inject } from '@angular/core';
import { ConsumerEntityService } from '../../../consumer/services/consumer.entity.service';
import { EntityService } from '../../../core/services/entity.service';
import { GenericEntityStateClass, createEntityState } from '../../../core/state/entity.state';
import { SubjectEntityService } from '../../../subject/services/subject.entity.service';
import { ExamEntity } from '../exam.entity';

export const STATE_NAME = 'examEntity';

export const ExamEntityState: GenericEntityStateClass<ExamEntity> =
  createEntityState<ExamEntity>(STATE_NAME);

@Injectable({ providedIn: 'root' })
export class ExamEntityService extends EntityService<ExamEntity> {
  private consumerEntityService = inject(ConsumerEntityService);
  private subjectEntityService = inject(SubjectEntityService);

  constructor() {
    super();
    this.resourceType = 'exams';
    this.stateClass = ExamEntityState;

    this.registerRelation('consumers', this.consumerEntityService);
    this.registerRelation('subjects', this.subjectEntityService);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  allByQuery(query: Record<string, any> = {}) {
    const stateClass = this.stateClass;
    const sliceName = STATE_NAME;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (storeState: any): ExamEntity[] => {
      const slice = storeState[sliceName];
      return stateClass.allByQuery(slice, { query });
    };
  }
}
